import React from "react";
import RoleGuard from "../../../auth/RoleGuard";
import FundTerms from "./FundTerms";
import { FUND_TERMS_ROLES } from "./fundTermsModel";

/**
 * FundTermsRoute - the Fund terms screen behind RoleGuard (R4, Friday release
 * 2026-10-09; decision D7), mounted by App.js on /fund-terms and
 * /fund-terms/:campaignId. The allow list is FUND_TERMS_ROLES, the seats the
 * API admits (requireRole('AD', 'CCO') on every fund terms call), kept in one
 * place with the Sidebar item and the campaign view's entry.
 */
export default function FundTermsRoute() {
  return (
    <RoleGuard allow={FUND_TERMS_ROLES}>
      <FundTerms />
    </RoleGuard>
  );
}
